module.exports = __webpack_public_path__ + "img/certificate4.b1b9f8f5.jpg";